import callAPI from "../callApi";
import path from "../variables";

/**
 * Catalogue tarifaire (Root only). Endpoints S2 :
 *   - GET    /administration/pricing-catalog                 (filtres)
 *   - PUT    /administration/pricing-catalog/{featureKey}    (versioning auto)
 *   - GET    /administration/pricing-catalog/{featureKey}/history
 *   - PUT    /administration/enterprise-features/pricing     (override per-tenant)
 *   - GET    /administration/enterprise-features/billing-breakdown
 *
 * Le prix édité depuis l'UI part en POST/PUT vers le contrôleur Laravel
 * qui gère le versioning lossless (table feature_pricing_history) — pas
 * de logique métier côté front, juste l'I/O.
 */
const pricingCatalog = {
	getAll: (filter?: string) =>
		callAPI(
			"GET",
			`${path.base}/administration/pricing-catalog${filter ?? ""}`,
			"",
			"fetching pricing catalog",
		),

	update: (featureKey: string, data: any) =>
		callAPI(
			"PUT",
			`${path.base}/administration/pricing-catalog/${encodeURIComponent(featureKey)}`,
			data,
			"updating pricing catalog entry",
		),

	history: (featureKey: string) =>
		callAPI(
			"GET",
			`${path.base}/administration/pricing-catalog/${encodeURIComponent(featureKey)}/history`,
			"",
			"fetching pricing history",
		),

	// Override per-tenant — endpoint partagé avec EnterpriseFeatureController.
	updateEnterprisePricing: (data: {
		feature_key: string;
		enterprise: string; // uuid
		monthly_price: number | null;
		pricing_note?: string | null;
	}) =>
		callAPI(
			"PUT",
			`${path.base}/administration/enterprise-features/pricing`,
			data,
			"updating enterprise pricing override",
		),

	// Coût mensuel calculé d'une entreprise (Root cross-tenant via
	// ?enterprise=<uuid>, Admin self sans param). Utilisé par le widget
	// dashboard "Coût du mois en cours" et le wizard de souscription.
	billingBreakdown: (enterpriseUuid?: string) =>
		callAPI(
			"GET",
			`${path.base}/administration/enterprise-features/billing-breakdown${enterpriseUuid ? "?enterprise=" + encodeURIComponent(enterpriseUuid) : ""}`,
			"",
			"fetching billing breakdown",
			{ skipCache: true }, // facturation = donnée "fraîche" attendue
		),
};

export default pricingCatalog;
